import axios from 'axios'
import create from 'zustand'
import { persist } from 'zustand/middleware'
import Cookies from 'js-cookie'

let store = (set) => ({
   supervisor: {},
  supervisor_students: {},
  supervisors: {},
  supervisorCount: 0,
  getSupervisor: async () => {
    let token = Cookies.get('token')
    const id = Cookies.get('type')?.substring(40)?.split(',')?.[0] ?? -1

    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }
    const apiResponse = await axios.get(
      `${process.env.REACT_APP_API}/supervisor/${id}`,
      config
    )
    set(async (state) => {
      state.supervisor = apiResponse.data
    })
  },
  getSupervisorCount: async () => {
    // setting token
    let token = Cookies.get('token')

    // attach token to header
    // sort and order data by which column and how
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      }
    }
    // setting url 
    // main url comes from .env file
    const apiResponse = await axios.get(`${process.env.REACT_APP_API}/supervisor/getcount`, config)
    set(async (state) => {
      // initilize supervisors state variable to the responsed supervisors if request succeed
      if (apiResponse?.status == 200 || apiResponse?.status == 201)
        state.supervisorCount = apiResponse?.data?.supervisor ?? ''
    })
  },
  getsupervisors: async () => {
    let token = Cookies.get('token')

    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }
    const apiResponse = await axios.get(
      `${process.env.REACT_APP_API}/supervisor`,
      config
    )
    set(async (state) => {
      state.supervisors = apiResponse.data
    })
  },
  getsupervisorStudents: async () => {
    let token = Cookies.get('token')
    const id =  Cookies.get('type')?.substring(40)?.split(',')?.[0]??-1;

    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }
    const apiResponse = await axios.get(
      `${process.env.REACT_APP_API}/supervisor/${id}/students`,
      config
    )
    set(async (state) => {
      state.supervisor_students = apiResponse.data
    })
  },
  addsupervisor: async (payload) => {
    let token = Cookies.get('token')

    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }

    const apiResponse = await axios.post(
      `${process.env.REACT_APP_API}/supervisor`,
      payload,
      config
    )
    if (apiResponse?.status === 201) {
      set(async (state) => {
        state.supervisors = {
          data: [...state.supervisors.data, apiResponse.data],
          limit: state.supervisors.limit,
          page: state.supervisors.page,
          totalCount: state.supervisors.totalCount + 1,
        }
      })
    }
  },
  loginSupervisor: async (payload) => {
    const apiResponse = await axios.post(
      `${process.env.REACT_APP_API}/supervisorauth/supervisorlogin`,
      payload
    )
    if (apiResponse?.status === 201 || apiResponse?.status == 200) {
      set(async (state) => {
        state.supervisor = apiResponse?.data?.supervisor ?? ''
        // state.supervisor.token = apiResponse?.data?.token ?? 'null'
        // res.cookie('token', userToken, { httpOnly: true })

        const supervisorResult = apiResponse?.data?.supervisor ?? ''
        const supervisorId = supervisorResult?.id ?? ''
        const token = apiResponse?.data?.token ?? ''
        Cookies.set('token', token, {
          httpOnly: false,
          expires: 1,
          secure: true,
          sameSite: 'strict',
          path: '/',
        })
        Cookies.set('type', process.env.REACT_APP_SUL + supervisorId + ',', {
          httpOnly: false,
          expires: 1,
          secure: true,
          sameSite: 'strict',
          path: '/',
        })
        Cookies.set('image', supervisorResult?.image??'', {
          httpOnly: false,
          expires: 1,
          secure: true,
          sameSite: 'strict',
          path: '/',
        })
        Cookies.set('name', supervisorResult?.name ?? '', {
          httpOnly: false,
          expires: 1,
          secure: true,
          sameSite: 'strict',
          path: '/',
        })
      })
    }
    return apiResponse?.data ?? ''
  },
  logoutSupervisor: async () => {
    set(async (state) => {
      state.supervisor = {}
      Cookies.set('token', '', {
        httpOnly: false,
        expires: 1,
        secure: true,
        sameSite: 'strict',
        path: '/',
      })
      Cookies.set('type', '', {
        httpOnly: false,
        expires: 1,
        secure: true,
        sameSite: 'strict',
        path: '/',
      })
    })
  },
  putsupervisor: async (payload, id) => {
    let token = Cookies.get('token')

    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }

    const apiResponse = await axios.patch(
      `${process.env.REACT_APP_API}/supervisor/${id}`,
      payload,
      config
    )
    if (apiResponse?.status === 200) {
      set(async (state) => {
        for (let index = 0; index < state.supervisors.data.length; index++) {
          const element = state.supervisors.data[index]
          if (element.id == id) state.supervisors.data[index] = apiResponse.data
        }
      })
    }
  },
  deletesupervisor: async (id) => {
    let token = Cookies.get('token')

    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }

    const apiResponse = await axios.delete(
      `${process.env.REACT_APP_API}/supervisor/${id}`,
      config
    )
    if (apiResponse?.status === 200) {
      set(async (state) => {
        const arr = state.supervisors.data.filter((item) => item.id !== id)
        state.supervisors = {
          data: arr,
          limit: state.supervisors.limit,
          page: state.supervisors.page,
          totalCount: state.supervisors.totalCount - 1,
        }
      })
    }
  },
})

// store = persist(store, { name: 'supervisor' })

const supervisor_Store = create(store)

export default supervisor_Store
